import {
  Alert,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import * as React from 'react';
import { memo } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { IncludePHIDialogProps } from '../documentViewer/types';
import { RedactedCertifiedDialog } from './RedactedCertifiedDialog';

const IncludePHIDialog = ({
  setOpenPHI,
  handleClosePHI,
  setChecked,
  setDisablePHI,
  metaData,
  setMetaData
}: IncludePHIDialogProps) => {
  const [isRedacted, setIsRedacted] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const handleRedactedChange = (e: any) => {
    const value = e.target.value;
    setIsRedacted(value);
  };

  const handleSavePHI = () => {
    setChecked(true);
    setMetaData({ ...metaData, isf_doc_viewer_doc_phi_redacted: isRedacted });
    setDisablePHI(true);
    if (isRedacted === 'Y') {
      setOpen(true);
    } else {
      setOpenPHI(false);
    }
  };

  return (
    <div className="versionControl-modal">
      <React.Fragment>
        <DialogTitle id="alert-dialog-title">{'Includes PHI'}</DialogTitle>
        <DialogContent className="phiModal" sx={{ pb: 0 }}>
          <DialogContentText id="alert-dialog-description">Has the document been redacted?</DialogContentText>

          <FormControl className="radio-section">
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              defaultValue={isRedacted}
              onChange={handleRedactedChange}
            >
              <FormControlLabel value={`Y`} control={<Radio />} label={'Yes'} />
              <FormControlLabel value={`N`} control={<Radio />} label={`No`} />
            </RadioGroup>
          </FormControl>

          <Box>
            {isRedacted === 'Y' && <Alert severity="info">The document will be sent to TMF</Alert>}
            {isRedacted === 'N' && <Alert severity="info">The document will not be sent to TMF</Alert>}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePHI} autoFocus className="grey-btn">
            Close
          </Button>
          <Button onClick={handleSavePHI} disabled={!isRedacted}>
            Save
          </Button>
        </DialogActions>
      </React.Fragment>
      <React.Fragment>
        <PopupComponent maxWidth="sm" open={open}>
          <RedactedCertifiedDialog
            setOpen={setOpen}
            handleClosePHI={handleClosePHI}
            setDisablePHI={setDisablePHI}
            metaData={metaData}
            setMetaData={setMetaData}
            setChecked={setChecked}
          />
        </PopupComponent>
      </React.Fragment>
    </div>
  );
};

export default memo(IncludePHIDialog);
